import React from "react";

// components
import { Filter } from "../../../components/FilterChips/FilterChips";
import { WORKFLOW_STATUS_OPTIONS, WorkflowsFilters } from "./WorkflowsFilterPanel";

import ReadableFilterChipsShell from "../ReadableFilterChipsShell";

const convertFiltersToReadableList = (filters: Partial<WorkflowsFilters>): Filter[] => {
	const readableList: Filter[] = [];

	if (filters.workflowName) {
		readableList.push({
			id: "workflowName",
			type: "string",
			label: "Workflow",
			value: filters.workflowName,
		});
	}

	if (filters.subject) {
		readableList.push({
			id: "subject",
			type: "single-employee",
			label: "Subject",
			value: { id: filters.subject.id, name: filters.subject.name },
		});
	}

	if (filters.status && filters.status !== "any") {
		readableList.push({
			id: "status",
			type: "string",
			label: "Status",
			value: WORKFLOW_STATUS_OPTIONS.find((option) => option.value === filters.status)?.label ?? filters.status,
		});
	}

	if (filters.overdueOnly && filters.overdueOnly.length > 0) {
		readableList.push({
			id: "overdueOnly",
			type: "customRender",
			label: "",
			value: <span>Only workflows with overdue to-dos</span>,
		});
	}

	if (filters.unassignedOnly && filters.unassignedOnly.length > 0) {
		readableList.push({
			id: "unassignedOnly",
			type: "customRender",
			label: "",
			value: <span>Only workflows with unassigned to-dos</span>,
		});
	}

	return readableList;
};

type ReadableWorkflowsFilterChipsProps = {
	filters: Partial<WorkflowsFilters>;
	setFilters: (newFilters: Partial<WorkflowsFilters>) => void;
};

const ReadableWorkflowsFilterChips = ({ filters, setFilters }: ReadableWorkflowsFilterChipsProps) => (
	<ReadableFilterChipsShell<WorkflowsFilters>
		filters={filters}
		setFilters={setFilters}
		convert={convertFiltersToReadableList}
	/>
);

export default ReadableWorkflowsFilterChips;
